export const fi = {
  appName: "Rukousajat",
  tabs: {
    prayer: "Rukous",
    qiblah: "Qibla",
    masjid: "Moskeija",
    settings: "Asetukset",
    more: "Lisää"
  },
  prayer: {
    nextPrayer: "Seuraava rukous",
    locating: "Määritetään sijaintia...",
    now: "Nyt",
    fajr: "Fajr",
    sunrise: "Auringonnousu",
    dhuhr: "Dhuhr",
    asr: "Asr",
    maghrib: "Maghrib",
    isha: "Isha",
    loading: "Ladataan…",
    nextPrayerIn: "Seuraava rukous:",
    in: "om",
    today: "Tänään"
  },
  qiblah: {
    title: "Qibla-kompassi",
    subtitle: "Käännä laitetta merkkien kohdistamiseksi",
    compass: "Kompassi",
    direction: "Suunta",
    gettingLocation: "Haetaan sijaintia…",
    locationPermissionRequired: "Sijaintilupa vaaditaan.",
    refresh: "Päivitä"
  },
  masjid: {
    title: "Etsi moskeija",
    placeholder: "Hae osoitteella tai kaupungilla...",
    searching: "Haetaan Google Mapsista...",
    viewOnMaps: "Näytä Google Mapsissa",
    noResults: "Tuloksia ei löytynyt läheltä.",
    local: "Paikalliset",
    search: "Haku"
  },
  settings: {
    title: "Asetukset",
    location: "Sijainti",
    manual: "Manuaalinen sijainti",
    cityCountry: "Hae kaupunki...",
    latitude: "Leveysaste",
    longitude: "Pituusaste",
    calc: "Laskenta",
    calcMethod: "Laskentamenetelmä",
    asrMethod: "Asr-menetelmä",
    appearance: "Ulkoasu",
    lang: "Kieli",
    theme: "Teema",
    system: "Järjestelmä",
    light: "Vaalea",
    dark: "Tumma",
    save: "Tallenna",
    adhanEnabled: "Ota adhan käyttöön",
    persistentNotifications: "Pysyvät ilmoitukset",
    ishaTime: "Isha-aika",
    fajrTime: "Fajr-aika",
    ishaDefault: "Oletus",
    fajrDefault: "Oletus",
    minAfterMaghrib: "Minuuttia Maghribin jälkeen",
    minBeforeSunrise: "Minuuttia ennen auringonnousua",
    fixedTime: "Kiinteä aika",
    prayers: "Rukoukset",
    muslimWorldLeague: "Muslim World League",
    standard: "Standardi"
  },
  more: {
    back: "Takaisin",
    tasbih: "Tasbih",
    reset: "Nollaa",
    count: "Laske",
    hijri: "Hijri-kalenteri",
    now: "Nyt",
    highlights: "Kuukauden kohokohdat",
    events: "Tapahtumat & Uutiset",
    ramadan: "RAMADANIN ALKU",
    eid: "EID AL-ADHA",
    duas: "Päivittäiset duat",
    kahf: "Suura Al-Kahf",
    listenFull: "KUUNTELE KOKO SUURA",
    pause: "TAUKO",
    stats: "Rukoustilastot",
    statsDesc: "Aikapituudet päivittäisten rukoushetkien välillä",
    fajrToMaghrib: "Fajr - Maghrib",
    dhuhrToAsr: "Dhuhr - Asr",
    sunriseToSunset: "Auringonnousu - lasku",
    fajrToSunrise: "Fajr - Auringonnousu",
    maghribToIsha: "Maghrib - Isha",
    appInfo: "Sovelluksen tiedot",
    zakat: "Zakat-laskuri",
    zakatDesc: "Laske zakatisi (2,5% varallisuudesta)",
    zakatTotal: "ZAKAT MAKSETTAVA",
    cashSavings: "Käteinen / Säästöt",
    goldValue: "Kullan arvo",
    silverValue: "Hopean arvo",
    nisabNote: "Varmista, että varallisuutesi ylittää Nisab-kynnyksen ennen zakatin maksamista",
    inheritance: "Perinnönlaskuri",
    inheritanceDesc: "Laske islamilainen perinnönjako",
    estateValue: "Kuolinpesän arvo",
    selectHeirs: "Valitse perilliset",
    heirHusband: "Aviomies",
    heirWife: "Vaimo",
    heirFather: "Isä",
    heirMother: "Äiti",
    heirSon: "Poika",
    heirDaughter: "Tytär",
    distribution: "JAKAUTUMINEN",
    share: "osuus",
    disclaimer: "Tämä on yksinkertaistettu laskenta. Kysy oppineelta monimutkaisissa tapauksissa.",
    namesOfAllah: "Allahin 99 nimeä",
    nameNumber: "NIMI #",
    spiritualBenefit: "Hengellinen hyöty",
    weekDays: ["S", "M", "T", "K", "P", "L", "S"],
    monthly: "Kuukausittaiset ajat",
    halalPlaces: "Halal-paikat",
    trains: "Junat",
    less: "Vähemmän",
    more: "Lisää...",
    downloadApp: "Lataa mobiilisovellus",
    adjustHijri: "Säädä Hijri-päivämäärää",
    hijriCycle: "Hijri-kierto",
    year: "Vuosi",
    thisYear: "Tämä vuosi",
    tenYearOverview: "10 vuoden yleiskatsaus",
    ayahs: "Ayahit",
    ayah: "AYAH",
    fetchingAyahs: "Haetaan ayaheja...",
    morning: "Aamu",
    evening: "Ilta",
    prayerStatistics: "Rukoustilastot",
    prayerIntervals: "Rukousaikojen välit",
    daylightHours: "Päivänvalotunnit",
    afternoonPeriod: "Iltapäiväjakso",
    fullDaylight: "Täysi päivänvalo",
    dawnPeriod: "Aamujakso",
    eveningPeriod: "Iltajakso",
    errorLoading: "Virhe ladattaessa tilastoja",
    loadingStats: "Ladataan tilastoja...",
    sons: "Pojat",
    daughters: "Tyttäret",
    searchHalal: "Hae halal-paikkoja",
    searching: "Haetaan...",
    noResults: "Tuloksia ei löytynyt",
    viewOnMaps: "Näytä kartalla",
    selectStation: "Valitse asema",
    favorites: "Suosikit",
    useCurrentLocation: "Käytä nykyistä sijaintia",
    refresh: "Päivitä",
    loading: "Ladataan...",
    dataSource: "Tiedot Liikenneviraston Digital API:sta. Lisensoitu Creative Commons Attribution 4.0 -lisenssillä",
    appVersion: "Versio",
    appDescription: "Rukousajat ja islamilaiset työkalut Suomelle"
  },
  trains: {
    useCurrentLocation: "Oma sijainti",
    selectStation: "Valitse asema",
    noTrainsFound: "Junia ei löytynyt",
    time: "Aika",
    track: "Raide",
    train: "Juna",
    destination: "Määränpää",
    cancelled: "Peruttu"
  },
  ramadan: {
    title: "Ramadan 2026",
    expected: "Odotettu:",
    date: "18-19 helmi",
    daysLeft: "päivää jäljellä",
    today: "Tänään!",
    fastingHours: "Paastotunnit"
  }
};
